import * as React from 'react';
import { Link } from 'react-router-dom';
import { fetchMeasurements, MeasurementsResponse } from '../api/plantyst';
import { Loading } from './Loading';
import { OnlineRowDto, WidgetDto } from './PageModels';

export interface OnlineWidgetProps {
    widget: WidgetDto;
    updateOnlineRowLocal(row: OnlineRowDto): void;
    addOnlineRowLocal(row: OnlineRowDto): void;
    sendToServer(): void;
    removeOnlineRow(onlineRowId: number): void;
    onlineRowKeys: { [id: number]: number; };
}

interface State {
    addingNewRow: boolean;
    newRow: Partial<OnlineRowDto>;
    measurements?: MeasurementsResponse;
    isLoading: boolean;
}

export class OnlineWidget extends React.Component<OnlineWidgetProps, State> {

    constructor(props: OnlineWidgetProps) {
        super(props);
        this.state = {
            addingNewRow: false,
            newRow: { onlineRowId: -1 },
            isLoading: true,
        };
    }

    async componentDidMount() {
        const measurements = await fetchMeasurements();
        this.setState({ measurements, isLoading: false });
    }

    render() {
        if (this.state.isLoading) {
            return <Loading />;
        }

        const widget = this.props.widget;
        let rows: Partial<OnlineRowDto>[] = this.props.widget.onlineRows || [];
        if (this.state.addingNewRow) {
            rows = rows.concat(this.state.newRow);
        }
        const measurements = this.state.measurements?._embedded?.measurement || [];
        const measurementIds: { [id: number]: true; } = {};
        measurements.forEach(p => measurementIds[p.measurementId] = true);
        const measurementsWithUnknown = measurements.concat((this.props.widget.onlineRows || [])
            .filter(p => !measurementIds[p.measurementId])
            .map(p => ({ measurementId: p.measurementId, title: p.measurementId.toString() })));
        return <>
            <h3>Online rows <Link to="#" onClick={() => this.addOnlineRow(widget)}>
                <i className="bi-plus-circle add-icon"></i>
            </Link></h3>
            <table className="table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Measurement</th>
                        <th>Time span (minutes)</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => <tr key={this.props.onlineRowKeys[row.onlineRowId!] || row.onlineRowId}>
                        <td>{index + 1}</td>
                        <td><select className="form-control" value={row.measurementId || ""} onChange={p => this.addOrUpdateOnlineRow(row,
                            { measurementId: p.target.value === "" ? 0 : parseInt(p.target.value) })} onBlur={this.props.sendToServer}>
                            {!row.measurementId && <option value=""></option>}
                            {measurementsWithUnknown.map(p =>
                                <option key={p.measurementId} value={p.measurementId}>{p.title}</option>)}
                        </select></td>
                        <td><input className="form-control" value={row.timeSpan || ""} onChange={p => this.addOrUpdateOnlineRow(row,
                            { timeSpan: p.target.value === "" ? 0 : parseInt(p.target.value) })} onBlur={this.props.sendToServer} /></td>
                        <td>
                            <Link to="#" onClick={() => this.removeOnlineRow(row)}>Delete</Link>
                        </td>
                    </tr>)}
                </tbody>
            </table>
        </>;
    }

    removeOnlineRow(row: Partial<OnlineRowDto>) {
        if (row.onlineRowId === this.state.newRow.onlineRowId) {
            this.setState({ newRow: { onlineRowId: this.state.newRow.onlineRowId }, addingNewRow: false });
        } else {
            if (window.confirm(`Do you really want to delete the row?`)) {
                this.props.removeOnlineRow(row.onlineRowId!);
                this.props.sendToServer();
            }
        }
    }

    addOrUpdateOnlineRow(row: Partial<OnlineRowDto>, changes: Partial<OnlineRowDto>) {
        if (row.onlineRowId === this.state.newRow.onlineRowId) {
            this.addOrUpdateNewOnlineRow(changes);
        } else {
            this.props.updateOnlineRowLocal({ ...row, ...changes } as OnlineRowDto);
        }
    }

    addOrUpdateNewOnlineRow(changes: Partial<OnlineRowDto>) {
        const result: Partial<OnlineRowDto> = { ...this.state.newRow, ...changes };
        if (result.measurementId != null && result.timeSpan != null) {
            this.props.addOnlineRowLocal(result as OnlineRowDto);
            this.setState({ newRow: { onlineRowId: this.state.newRow.onlineRowId! - 1 }, addingNewRow: false });
        } else {
            this.setState({ newRow: result });
        }
    }

    addOnlineRow(widget: WidgetDto) {
        this.setState({ addingNewRow: true });
    }
}
